import * as React from "react";
import { forwardRef } from "react";
const ParkingSensorsIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M5.073 18.596a.75.75 0 0 1 .75.75 2.88 2.88 0 0 0 2.583 2.862l.294.015.076.004a.75.75 0 0 1 0 1.492l-.076.004-.226-.006a4.38 4.38 0 0 1-4.151-4.371.75.75 0 0 1 .75-.75zm13.927 0a.75.75 0 0 1 .75.75 4.38 4.38 0 0 1-4.377 4.377.75.75 0 1 1 0-1.5 2.88 2.88 0 0 0 2.877-2.877.75.75 0 0 1 .75-.75z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13.531 4.085c1.835 0 3.307 1.505 3.307 3.34v2.947l.632.327a.75.75 0 0 1-.632 1.354v6.786c0 1.12-.899 2.045-2.028 2.045H9.19a2.037 2.037 0 0 1-2.028-2.045v-6.785a.75.75 0 0 1-.648-1.345l.648-.355V7.425c0-1.835 1.472-3.34 3.307-3.34h3.063zm1.807 12.949a9.789 9.789 0 0 1-3.311.614c-1.144.017-2.312-.157-3.365-.546v1.737c0 .31.246.545.528.545h5.62a.536.536 0 0 0 .528-.545v-1.806zm0-5.658c-2.093-.736-4.588-.778-6.677-.029v4.13c.958.462 2.137.69 3.343.672s2.382-.281 3.334-.746v-4.026zm-4.87-5.791c-.988 0-1.806.815-1.807 1.84v2.344c2.145-.644 4.556-.602 6.677.032V7.425c0-1.025-.818-1.84-1.807-1.84h-3.063z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.7 1.68a.75.75 0 1 1 0 1.5 2.88 2.88 0 0 0-2.877 2.877.75.75 0 1 1-1.5 0A4.38 4.38 0 0 1 8.7 1.68zm6.898.006a4.38 4.38 0 0 1 4.152 4.371.75.75 0 1 1-1.5 0 2.88 2.88 0 0 0-2.583-2.862l-.371-.019a.75.75 0 0 1 .077-1.496l.225.006z"
}));
const ForwardRef = forwardRef(ParkingSensorsIcon);
export default ForwardRef;